import styled from 'styled-components';
export const Header = styled.div `
  ${({ theme: { colors, font, space } }) => `
    && {
      display: flex;
      align-items: center;
      min-height: 48px;
      background-color: ${colors['slate-100']};
      color: ${colors['gray-900']};
      padding: 0 ${space.md};
  
      h1, h2, h3, h4, h5, h6 {
        font-size: ${font.body.md.size};
        line-height: ${font.body.md.lineHeight};
      }
    }
  `}
`;
const flexColWidth = (colCount) => {
    switch (colCount) {
        case '1':
            return '100%';
        case '2':
        default:
            return '50%';
    }
};
export const StyledTableCardList = styled.section `
  ${({ $disableContainer, $colCount, theme: { colors, font, space }, }) => `
    ul {
      margin: 0;
      padding: 0;
      list-style: none;

      li {
        background: ${colors.white};
        margin-bottom: ${space.xs};
        border-radius: 4px;
        overflow: hidden;

        &:last-child {
          margin-bottom: ${space.none};
        }

        ${!$disableContainer
    ? `box-shadow:
                0 0 0 1px ${colors['gray-300']},
                0 2px 4px -2px rgba(0,0,0,0.16),
                0 5px 8px -4px rgba(0,0,0,0.16);`
    : ''}

        dl {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          padding: ${space.md} ${space.md} 0;
          margin: 0;

          div {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            flex: 0 ${flexColWidth($colCount)};
            margin-bottom: ${space.md};

            dt {
              font-size: ${font.body.sm.size};
              line-height: ${font.body.sm.lineHeight};
              color: ${colors['gray-700']};
            }

            dd {
              font-weight: bold;
              font-size: ${font.body.md.size};
              line-height: ${font.body.md.lineHeight};
              color: ${colors['gray-900']};
              margin: 0;
            }
          }
        }
      }
    }
  `}
`;
//# sourceMappingURL=styles.js.map